import {
    SHOW_MULTI_PDP_VISITS,
    SHOW_PDP_SOURCING,
    SHOW_PDP_TRADE_ONBOARDING,
    SHOW_PDP_TRADE_NEGOTIATION_TOAST,
    SHOW_PDP_TRADE_HOLD_REQUEST_TOAST,
    SHOW_PDP_TRADE_NEGOTIATION_MODAL,
    SHOW_PDP_TRADE_ON_APPROVAL_CALLOUT,
    NOTIFICATION_KEYS as SHARED_NOTIFICATION_KEYS,
} from '../pdp/PdpSharedNotifications/pdpSharedNotificationConstants';

export function pdpRespNotificationsReducer(state, action) {
    switch (action.type) {
        case SHOW_MULTI_PDP_VISITS:
            return {
                ...state,
                notifications: { [SHARED_NOTIFICATION_KEYS.MULTI_PDP_VISITS]: true },
            };
        case SHOW_PDP_SOURCING:
            return {
                ...state,
                notifications: { [SHARED_NOTIFICATION_KEYS.PDP_SOURCING_MODAL]: true },
            };
        case SHOW_PDP_TRADE_ONBOARDING:
            return {
                ...state,
                notifications: { [SHARED_NOTIFICATION_KEYS.PDP_TRADE_ONBOARDING_MODAL]: true },
            };
        case SHOW_PDP_TRADE_NEGOTIATION_TOAST:
            return {
                ...state,
                notifications: {
                    [SHARED_NOTIFICATION_KEYS.PDP_TRADE_NEGOTIATION_TOAST]: true,
                },
            };
        case SHOW_PDP_TRADE_HOLD_REQUEST_TOAST:
            return {
                ...state,
                notifications: {
                    [SHARED_NOTIFICATION_KEYS.PDP_TRADE_HOLD_REQUEST_TOAST]: true,
                },
            };
        case SHOW_PDP_TRADE_NEGOTIATION_MODAL:
            return {
                ...state,
                notifications: {
                    [SHARED_NOTIFICATION_KEYS.PDP_TRADE_NEGOTIATION_MODAL]: true,
                },
            };
        case SHOW_PDP_TRADE_ON_APPROVAL_CALLOUT:
            return {
                ...state,
                notifications: {
                    [SHARED_NOTIFICATION_KEYS.PDP_TRADE_ON_APPROVAL_CALLOUT]: true,
                },
            };
        default:
            return state || { notifications: {} };
    }
}
